
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { process } from '@progress/kendo-data-query';
import { Chip } from '@progress/kendo-react-buttons';
import { setExpandedState, setGroupIds } from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridColumn, GridColumnMenuFilter, GridColumnMenuGroup, GridColumnMenuSort, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoaderOverlay from '../../components/custom-loader/LoaderOverlay';
import { getAllUserData } from '../../services/dashboard-service/userService';
import ActionCell from './ActionCell';


const initialDataState = {
    take: 100, // Number of items per page
    skip: 0,  // Current offset
    sort: [],
    filter: null,
    group: [],
};

const processWithGroups = (data, dataState) => {
    const newDataState = process(data, dataState);
    setGroupIds({
        data: newDataState.data,
        group: dataState.group
    });
    return newDataState;
};
function UserList({ userData }) {
    const excelExportRef = useRef(null);

    // const [selectedUser, setSelectedUser] = useState(null)
    const [collapsedState, setCollapsedState] = useState([]);
    const [filterValue, setFilterValue] = useState('')
    const [loading, setLoading] = useState(false)
    const [isDataAvailable, setIsDataAvailable] = useState(true);
    const navigate = useNavigate()
    const [filteredData, setFilteredData] = useState([]);
    const [dataResult, setDataResult] = useState(processWithGroups(filteredData, initialDataState));




    const [users, setUsers] = useState([]);
    const [gridData, setGridData] = useState([])
    const [dataState, setDataState] = useState(initialDataState);

    const exportExcel = () => {
        if (excelExportRef.current) {
            excelExportRef.current.save();
        }
    };

    const onExpandChange = useCallback(event => {
        const item = event.dataItem;
        if (item.groupId) {
            const collapsedIds = !event.value ? [...collapsedState, item.groupId] :
                collapsedState.filter(groupId => groupId !== item.groupId)
            setCollapsedState(collapsedIds)
        }
    }, [collapsedState])

    const formatDate = (date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };

    const fetchUserData = async () => {
        if (userData && !loading) {
            setLoading(true)
            let response = await getAllUserData(userData.SecretKey, userData.Token);
            if (response && response.data && response.data.users) {
                // const transformedData = response?.data?.users;
                const transformedData = response?.data?.users.map(user => ({
                    ...user,
                    EndDate: formatDate(new Date(user.EndDate)),
                }));
                setIsDataAvailable(transformedData.length > 0)
                setUsers(transformedData)
                setFilteredData(transformedData)
                const processedData = processWithGroups(transformedData, initialDataState);
                setDataResult(processedData); // Initialize processed data for Grid
                console.log("inital data fetching for user ->",processedData)
                setDataState(prevState => ({
                    ...prevState,
                    skip: 0 // Reset to the first page
                }));
            }
            else if (response?.error?.statusCode === 401 || response?.error?.message === "Error verifying token : jwt expired") {
                localStorage.removeItem("userData")
                setIsDataAvailable(false)
                navigate('/login')
                toast.error('Session Expired.')
            }
            else if (response?.status === 401) {
                setIsDataAvailable(false)
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
            }
            setLoading(false)
        }
    }




    useEffect(() => {
        fetchUserData()
    }, [])


    const dataStateChange = (event) => {
        const updatedState = event.dataState;
        setDataState(updatedState);
        setGridData(processWithGroups(filteredData, updatedState));
        setDataResult(processWithGroups(filteredData, event.dataState))
    };




    const ActiveStatusCell = (props) => {
        const { dataItem } = props;
        const isActive = dataItem.Active;
        return (
            <td style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Chip text={isActive ? "ACTIVE" : "IN ACTIVE"} style={{
                    fontWeight: 700,
                    textAlign: "center",

                    width: "82px",
                    fontSize: "0.7rem",
                    backgroundColor: isActive ? 'rgb(232, 245, 233)' : 'rgb(255, 205, 210)',
                    color: isActive ? 'rgb(46, 125, 50)' : 'rgb(198, 40, 40)'
                }}>
                </Chip>
            </td>
        )
    }


    const newData = setExpandedState({
        data: dataResult.data || [],
        collapsedIds: collapsedState
    });


    useEffect(() => {
        // Perform filtering based on the filterValue and the current data state
        const filteredData = users.filter(user => {
            return Object.values(user).some(property => {
                return property != null && property.toString().toLowerCase().includes(filterValue.toLowerCase());
            });
        });
        const processedData = process(filteredData, dataState);
        setGridData(processedData);
    }, [dataState, filterValue, users]);





    const onFilterChange = (e) => {
        const value = e.target.value.toLowerCase();
        setFilterValue(value);

        // Filter the data based on the input value
        const filteredData = users.filter(user => {
            return Object.values(user).some(property => {
                return property != null && property.toString().toLowerCase().includes(value);
            });
        });

        // Reset pagination and update the data state
        setDataState({
            ...dataState,
            skip: 0, // Reset to the first page when filter is applied
        });

        // Process the filtered data
        const processedData = process(filteredData, { ...dataState, skip: 0 });
        setFilteredData(filteredData);
        setDataResult(processedData);
    };
    if (loading) {
        return (
            <LoaderOverlay loading={loading} />
        );
    }
    return (
        <div className='userlist-main-div' style={{ height: "100%" }}>
            <div className='userlist-grid' style={{ height: "100%" }}>
                <ExcelExport data={gridData.data} fileName="User_List.xlsx" ref={excelExportRef}>
                    <Grid
                        pageable={isDataAvailable ? {
                            buttonCount: 4,
                            pageSizes: [100, 200, 500, 1000],
                        } : false}
                        data={newData}
                        total={dataResult.total}
                        group={dataState?.group}
                        groupable
                        sortable
                        onDataStateChange={dataStateChange}
                        onExpandChange={onExpandChange}
                        expandField="expanded"
                        {...dataState}
                        excelExport={exportExcel}
                        style={{ height: '100%' }}
                    >
                        <GridNoRecords>
                            {!isDataAvailable && !loading && (
                                <div className="no-data-found">
                                    <div className="no-data-icon">
                                        <FontAwesomeIcon icon={faCircleExclamation} size="7x" />
                                    </div>
                                    <div className="no-data-message">
                                        No Data Available
                                    </div>
                                </div>
                            )}
                            <></>
                        </GridNoRecords>
                        <GridToolbar>
                            <div className='header-div'>
                                <div className='input-filters'>
                                    <Input
                                        value={filterValue}
                                        disabled={!dataResult}
                                        onChange={(e) => onFilterChange(e)}
                                        style={{ border: '2px solid #ccc', width: '210px', height: '30px', marginRight: '10px' }}
                                        placeholder="Search in all columns..."
                                    />
                                </div>
                            </div>
                        </GridToolbar>

                        <GridColumn
                            field="FirstName"
                            title="First Name"
                            flex={1}
                            style={{ textAlign: "center" }}
                            columnMenu={ColumnMenu}

                        />
                        <GridColumn
                            field="LastName"
                            title="Last Name"
                            flex={1}
                            style={{ textAlign: "left" }}
                            columnMenu={ColumnMenu}

                        />
                        <GridColumn
                            field="Email"
                            title="Email Address"
                            flex={1}
                            style={{ textAlign: "left" }}
                            columnMenu={ColumnMenu}
                        />
                        <GridColumn
                            field="Active"
                            title="Active"
                            cells={{ data: ActiveStatusCell }}
                            flex={1}
                            style={{ textAlign: "left" }}
                            columnMenu={ColumnMenu}

                        />
                        <GridColumn
                            field="EndDate"
                            title="End Date"
                            format="{0:yyyy-MM-dd}"
                            flex={1}
                            style={{ textAlign: "left" }}
                            columnMenu={ColumnMenu}
                        />
                        <GridColumn className='k-link-action' title="Actions" flex={1} cells={{ data: (props) => <ActionCell dataItem={props.dataItem} fetchUserData={fetchUserData} userData={userData} /> }} />
                    </Grid>
                </ExcelExport>
            </div>
        </div>
    )
}


const ColumnMenu = (props) => (
    <div>
        <GridColumnMenuSort {...props} />
        <GridColumnMenuFilter {...props} />
        <GridColumnMenuGroup {...props} />
    </div>
);

export default UserList